// Centralized API base URL configuration.
// In containers (Docker / Azure), all API calls use relative URLs
// so nginx can reverse-proxy them to the backend.
// For local dev without Docker, set REACT_APP_API_URL=http://localhost:8002
const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8002';

export default API_BASE;
